var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 44C0 19.6995 19.6995 0 44 0C68.3005 0 88 19.6995 88 44C88 68.3005 68.3005 88 44 88C19.6995 88 0 68.3005 0 44Z",
    fill: "#E1292B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2083_47753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.658 65H39.3246L41.658 48.6667H33.4913C32.138 48.6667 32.1613 47.92 32.6046 47.1267C33.048 46.3333 32.7213 46.94 32.768 46.8467C35.778 41.5267 40.3046 33.5933 46.3246 23H48.658L46.3246 39.3333H54.4913C55.6346 39.3333 55.798 40.1033 55.588 40.5233L55.4246 40.8733C46.2313 56.95 41.658 65 41.658 65Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2083_47753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyBattery);
export default __webpack_public_path__ + "static/media/body-battery.7ee9951d5f042fc0ee295f2df2eb4a89.svg";
export { ForwardRef as ReactComponent };